import * as actionTypes from './actionTypes';
import * as actions from './actions';
import * as typings from './typings';

export const appInfoActionTypes = actionTypes;
export const appInfoActions = actions;
export const appInfoTypings = typings;
